import {
  LEGACY_BREAKPOINT_QUERIES,
  createResponsiveBreakpointQuery
} from 'styles/breakpoints'

export const releaseInfoMobileDownQuery = createResponsiveBreakpointQuery(
  'mobileDown',
  { legacyQuery: LEGACY_BREAKPOINT_QUERIES.mobileDown }
)

export const releaseInfoTabletUpQuery = createResponsiveBreakpointQuery(
  'tabletUp',
  { legacyQuery: LEGACY_BREAKPOINT_QUERIES.tabletUp }
)

export const releaseInfoTabletDownQuery = createResponsiveBreakpointQuery(
  'tabletDown',
  { legacyQuery: LEGACY_BREAKPOINT_QUERIES.tabletDown }
)

export const releaseInfoSmallDesktopQuery = createResponsiveBreakpointQuery(
  'smallDesktop',
  { legacyQuery: LEGACY_BREAKPOINT_QUERIES.smallDesktop }
)

export const releaseInfoSmallDesktopUpQuery = createResponsiveBreakpointQuery(
  'smallDesktopUp',
  { legacyQuery: LEGACY_BREAKPOINT_QUERIES.smallDesktopUp }
)

export const releaseInfoDesktopContentUpQuery = createResponsiveBreakpointQuery(
  'desktopUp',
  { legacyQuery: LEGACY_BREAKPOINT_QUERIES.releaseInformationTabsUp }
)

export const releaseInfoLargeDesktopUpQuery = createResponsiveBreakpointQuery(
  'largeDesktopUp',
  {
    legacyQuery: LEGACY_BREAKPOINT_QUERIES.largeDesktopUp
  }
)

export const releaseInfoCoverControlsDownQuery =
  createResponsiveBreakpointQuery('smallDesktopDown', {
    legacyQuery: LEGACY_BREAKPOINT_QUERIES.releaseInformationCoverControlsDown
  })

export const releaseInfoPromoWideUpQuery = createResponsiveBreakpointQuery(
  'largeDesktopUp',
  { legacyQuery: LEGACY_BREAKPOINT_QUERIES.releaseInformationPromoWideUp }
)

export const releaseInfoReactGridLargeUpQuery = createResponsiveBreakpointQuery(
  'smallDesktopUp',
  {
    legacyQuery: LEGACY_BREAKPOINT_QUERIES.reactGridLargeUp
  }
)

export const releaseInfoReactGridExtraExtraLargeUpQuery =
  createResponsiveBreakpointQuery('largeDesktopUp', {
    legacyQuery: LEGACY_BREAKPOINT_QUERIES.reactGridExtraExtraLargeUp
  })

// These thresholds preserve intentional visual tuning beyond the device scale.
// Keep them local to Release Information rather than promoting them to global
// breakpoint tokens.
export const RELEASE_INFORMATION_LAYOUT_QUERIES = Object.freeze({
  attachmentUltraWideUp: '(min-width: 1720px)',
  sidePanelUltraWideUp: '(min-width: 1920px)',
  coverArtMediumUp: '(min-width: 1980px)',
  promoExtraWideUp: '(min-width: 2150px)',
  coverArtLargeUp: '(min-width: 2560px)'
})
